import { Document } from '@contentful/rich-text-types'

export default function QuoteBlock({ entry }: { entry: Document }) {
  const { quote, lineColour } = entry?.data?.target?.fields || {}
  return (
    <div className="flex max-md:gap-4 gap-6 xl:gap-8">
      <div
        style={{
          borderLeft: '4px solid',
          borderColor: lineColour,
          borderRadius: '32px',
          margin: '6px 0',
        }}
      />
      <p className="text-s text-neutral-100">{quote}</p>
    </div>
  )
}
